var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 1.42968L4.83304 3.73687C4.60942 4.04636 4.30273 4.27928 3.95204 4.40594L1.33772 5.35016L2.9218 7.7203C3.13429 8.03824 3.25144 8.41511 3.25831 8.80289L3.30954 11.6936L5.95551 10.8513C6.31046 10.7383 6.68955 10.7383 7.04449 10.8513L9.69046 11.6936L9.74169 8.80289C9.74857 8.41511 9.86571 8.03824 10.0782 7.7203L11.6623 5.35016L9.04797 4.40594C8.69727 4.27928 8.39058 4.04636 8.16697 3.73687L6.5 1.42968ZM7.09653 0.310473C6.79744 -0.103492 6.20256 -0.103491 5.90347 0.310474L3.93824 3.03048C3.8488 3.15428 3.72612 3.24745 3.58584 3.29811L0.503755 4.41128C0.0346853 4.58069 -0.149142 5.17208 0.135079 5.59734L2.00259 8.39156C2.08758 8.51874 2.13444 8.66948 2.13719 8.82459L2.19759 12.2326C2.20678 12.7512 2.68804 13.1167 3.1628 12.9656L6.28221 11.9725C6.42418 11.9273 6.57582 11.9273 6.7178 11.9725L9.83721 12.9656C10.312 13.1167 10.7932 12.7512 10.8024 12.2326L10.8628 8.82459C10.8656 8.66948 10.9124 8.51874 10.9974 8.39156L12.8649 5.59734C13.1491 5.17208 12.9653 4.58069 12.4962 4.41128L9.41416 3.29811C9.27388 3.24745 9.15121 3.15428 9.06176 3.03048L7.09653 0.310473Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.5cbb40bc14bd3599f71d41d12436d947.svg";
export { ForwardRef as ReactComponent };